import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a36de3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 bg-light p-3" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Riders", -1))
const _hoisted_6 = { class: "col-12 bg-light p-3" }
const _hoisted_7 = { class: "row height d-flex justify-content-center align-items-center" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "search" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table table-striped table-sm" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Name"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Email"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Phone"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Device Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Vehicle Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Available"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Is Buzy"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Is Block"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Wallet Amount"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "text-start" }
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "text-start" }
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = { class: "btn-group mr-2" }
const _hoisted_27 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: "/drivers/live",
              class: "btn btn-sm btn-primary align-self-center text-right"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Live Riders")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/drivers/create",
              class: "btn btn-sm btn-primary align-self-center text-right pl-3 pr-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Riders")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/drivers/driverearningreportall",
              class: "btn btn-sm btn-primary align-self-center text-right"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Rider Earning Report")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/drivers/driverearningreport",
              class: "btn btn-sm btn-primary align-self-center text-right"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Rider Earning detail Report")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Search with Rider Name, Phone,Email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event))
                }, null, 512), [
                  [_vModelText, $setup.search]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.searchcall && $setup.searchcall(...args)))
                }, "Search"),
                _createElementVNode("button", {
                  class: "btn btn-primary clear",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.searchclear && $setup.searchclear(...args)))
                }, "Clear")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riders, (rider) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: rider.id
                  }, [
                    _createElementVNode("td", _hoisted_15, _toDisplayString(rider.id), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(rider.rider_name), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(rider.rider_email), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(rider.rider_phone), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(rider.device_type), 1),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(rider.vehicle_type), 1),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(rider.availability_status), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(rider.is_buzy), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(rider.is_block), 1),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(rider.country?.currency_short_name) + _toDisplayString(rider.wallet_amount), 1),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("a", {
                          target: "_blank",
                          href: `https://www.latlong.net/c/?lat=${rider.rider_lat}&long=${rider.rider_lan}`,
                          class: "btn btn-sm btn-success me-2"
                        }, " Rider Location", 8, _hoisted_27),
                        _createVNode(_component_router_link, {
                          to: `/drivers/${rider.id}/view`,
                          class: "btn btn-sm btn-warning me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" View")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: `/drivers/${rider.id}/edit`,
                          class: "btn btn-sm btn-secondary me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Edit")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_router_link, {
                          to: `/drivers/${rider.id}/detail`,
                          class: "btn btn-sm btn-info me-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Detail")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
        _cache[4] || (_cache[4] = ($event: any) => ($setup.load($event)))
      ],
      pages: $setup.lastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"])
  ], 64))
}